import styled from "@emotion/styled";

export const Main = styled.div`
	background-color: ${({ theme }) => theme.color.background};
	height: 100vh;
`;
